module.exports = __webpack_public_path__ + "static/media/download-icon.241553d1.svg";